import { fetchBidLimitBalanceIfNeeded } from './bidLimit';
import { fetchCatalogCuratorsIfNeeded } from './catalogCurators';
import { fetchCatalogDetailsIfNeeded } from './catalogDetail/catalogDetail.actions';
import { fetchSellerFollowerCountIfNeeded } from './sellerFollowerCount';
import { fetchSellerRatingSummaryByIdIfNeeded } from './sellerRatings';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchTopSellersIfNeeded } from './topRatedSellers';
import { getCatalogSellerId, getIsCatalogLoaded } from './catalog/catalog.selectors';
import { getNotFoundUrl } from '@/utils/urls';
import { push } from 'connected-react-router';

/* ACTION CREATORS */
export const fetchDataForCatalogPage = (catalogId: number) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const sellerId = getCatalogSellerId(state, catalogId);
    const loaded = getIsCatalogLoaded(state, catalogId);

    if (!sellerId && loaded) {
        return dispatch(push(getNotFoundUrl()));
    }

    return Promise.all([
        dispatch(fetchBidLimitBalanceIfNeeded({ catalogId })),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchCatalogCuratorsIfNeeded(catalogId)),
        dispatch(fetchTopSellersIfNeeded()),
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(fetchSellerFollowerCountIfNeeded([sellerId])),
        dispatch(fetchSellerRatingSummaryByIdIfNeeded(sellerId)),
    ]);
};
